var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-editSrt"},on:{"scroll":_vm.scrollChange}},[_c('Header'),_c('GlassEditor',{on:{"changeScrollHeigth":_vm.setScrollHeigth}}),_c('div',{staticClass:"fakeScroll"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }